import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import GXV3350 from '@/assets/images/3350.png';
import GXV3370 from '@/assets/images/3370.png';
import GXV3380 from '@/assets/images/3380.png';
import GXV3470 from '@/assets/images/3470.png';
import GAC2570 from '@/assets/images/2570.png';

import { useProduct } from '@/store';
import './index.less';

const Home: FC = () => {
  const [, setProduct] = useProduct();
  const history = useHistory();

  const jump = (product: Product) => {
    setProduct(product);
    history.push(`/${product}/settings`);
  };

  return (
    <div className='page-home'>
      <div className='product-item' onClick={() => jump('gxv3370')}>
        <img src={GXV3370} alt='GXV3370' />
        <span>GXV3370</span>
      </div>
      <div className='product-item' onClick={() => jump('gxv3380')}>
        <img src={GXV3380} alt='GXV3380' />
        <span>GXV3380</span>
      </div>
      <div className='product-item' onClick={() => jump('gxv3350')}>
        <img src={GXV3350} alt='GXV3350' />
        <span>GXV3350</span>
      </div>
      <div className='product-item' onClick={() => jump('gxv3470')}>
        <img
          src={GXV3470}
          alt='GXV3470'
          style={{ position: 'relative', top: '-10px' }}
        />
        <span>GXV3470</span>
      </div>
      <div className='product-item' onClick={() => jump('gxv3480')}>
        <img src={GXV3380} alt='GXV3480' />
        <span>GXV3480</span>
      </div>
      <div className='product-item' onClick={() => jump('gxv3450')}>
        <img src={GXV3350} alt='GXV3450' />
        <span>GXV3450</span>
      </div>
      <div className='product-item' onClick={() => jump('gac2570')}>
        <img src={GAC2570} alt='GAC2570' />
        <span style={{ left: 12 }}>GAC2570</span>
      </div>
    </div>
  );
};

export default Home;
